import TutorialModal from './TutorialModal.container'

export default TutorialModal
